export class ViewModelEvent<T extends Function> {
    private _handlers: T[] = [];

    public listen(handler: T) {
        this._handlers.push(handler);
    }

    public invoke(args1?: any, args2?: any, args3?: any, args4?: any, args5?: any, args6?: any): Promise<any[]> {
        var promises: any[] = [];

        this._handlers.forEach(item => {
            ((currentItem: any) => {
                var promise = currentItem(args1, args2, args3, args4, args5, args6);
                if (promise) {
                    promises.push(promise);
                }
                else {
                    promise = new Promise((resolve, reject) => {
                        resolve();
                    });
                    promises.push(promise);
                }
            })(item);
        });

        return Promise.all(promises);
    }
}

export function callHttp(method, url, data?) {
    if (window['appService'].isDebug) {
        url = 'http://localhost:63899/' + url;
    }

    var promise = new Promise((resolve, reject) => {
        var oReq = new XMLHttpRequest();

        oReq.addEventListener("load", function (e) {
            if (e.currentTarget['status'] >= 400) {
                reject(e.currentTarget['responseText'] ? JSON.parse(e.currentTarget['responseText']) : null);
            } else {
                resolve(e.currentTarget['responseText'] ? JSON.parse(e.currentTarget['responseText']) : null);
            }
        });
        oReq.withCredentials = true;
        oReq.open(method, url);

        if (data) {
            oReq.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            oReq.send(JSON.stringify(data));
        } else {
            oReq.send();
        }
    });

    return promise;
}

export function getCookie(cookieName) {
    var value = document.cookie;
    var cookies = value.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var key = cookies[i].split('=')[0];
        if (key[0] === ' ') {
            key = key.substring(1);
        }

        var value1 = cookies[i].split('=')[1];
        if (key === cookieName) {
            return value1;
        }
    }

    return '';
}

export function setCookie(cookieName, cookieValue, expiryDays) {
    var cookie = cookieName + "=" + cookieValue + "; ";

    if (expiryDays) {
        var d = new Date();
        d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));

        var expires = "expires=" + d.toUTCString();
        cookie += expires;
    }

    document.cookie = cookie;
}

export function removeCookie(cookieName) {
    var value = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = value;
}

export function setLongCookie(cookieName, cookieValue) {
    setCookie(cookieName, cookieValue, 30);
}

export function generateUID(): string {
    // I generate the UID from two parts here 
    // to ensure the random number provide enough bits.
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    let firstPart1 = ("000" + firstPart.toString(36)).slice(-3);
    let secondPart1 = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart1 + secondPart1;
}

export function copyObject(obj1, obj2) {
    for (let property in obj1) {
        obj2[property] = obj1[property];
    }
}